import { Link } from 'react-router-dom'
import Logo from './Logo'

const G = {
  white:   '#FFFFFF',
  ink:     '#0A0A0A',
  blue:    '#4F8EF7',
  display: "'Barlow Condensed', sans-serif",
  body:    "'Space Grotesk', sans-serif",
  mono:    "'Space Grotesk', sans-serif",
}

const STRINGS = {
  FR: {
    tagline:  'Du terrain à l’analyse.',
    colProd:  'Produit',
    colCont:  'Contact',
    colLegal: 'Légal',
    features: 'Fonctionnalités',
    pricing:  'Tarifs',
    blog:     'Blog',
    contact:  'Contact',
    email:    'contact@insightball.com',
    mentions: 'Mentions légales',
    cgv:      'CGV',
    conf:     'Confidentialité',
    cookies:  'Cookies',
    copy:     '© 2026 Insightball · Tous droits réservés',
  },
  EN: {
    tagline:  'From the pitch to the analysis.',
    colProd:  'Product',
    colCont:  'Contact',
    colLegal: 'Legal',
    features: 'Features',
    pricing:  'Pricing',
    blog:     'Blog',
    contact:  'Contact',
    email:    'contact@insightball.com',
    mentions: 'Legal notice',
    cgv:      'Terms',
    conf:     'Privacy',
    cookies:  'Cookies',
    copy:     '© 2026 Insightball · All rights reserved',
  },
}

const FOOTER_CSS = `
@media (max-width: 1024px) {
  .lfoot-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
}
@media (max-width: 600px) {
  .lfoot-grid { grid-template-columns: 1fr !important; gap: 28px !important; }
  .lfoot-bar  { padding: 40px 16px 24px !important; }
}
`

const SOCIALS = [
  { href: 'https://www.linkedin.com/company/insightball/', label: 'LinkedIn', d: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
  { href: 'https://www.instagram.com/insightball_',        label: 'Instagram', d: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
  { href: 'https://x.com/insightball_',                    label: 'X',         d: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
  { href: 'https://www.facebook.com/Insightball',          label: 'Facebook',  d: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
]

export default function LandingFooter({ lang = 'FR' }) {
  const t = STRINGS[lang] || STRINGS.FR

  const colLink = (h, l, key) => {
    const isRouter = h.startsWith('/') && !h.startsWith('/blog')
    const baseStyle = { fontSize: 13, fontFamily: G.mono, color: 'rgba(255,255,255,0.55)', textDecoration: 'none', transition: 'color .15s' }
    const enter = e => e.currentTarget.style.color = G.white
    const leave = e => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'
    return (
      <li key={key}>
        {isRouter ? (
          <Link to={h} style={baseStyle} onMouseEnter={enter} onMouseLeave={leave}>{l}</Link>
        ) : (
          <a href={h} style={baseStyle} onMouseEnter={enter} onMouseLeave={leave}>{l}</a>
        )}
      </li>
    )
  }

  const cols = [
    { title: t.colProd,  links: [['/#features', t.features], ['/tarifs', t.pricing], ['/blog/', t.blog]] },
    { title: t.colCont,  links: [['/#contact', t.contact], ['mailto:contact@insightball.com', t.email]] },
    { title: t.colLegal, links: [['/mentions-legales', t.mentions], ['/cgv', t.cgv], ['/confidentialite', t.conf], ['/cookies', t.cookies]] },
  ]

  return (
    <>
      <style>{FOOTER_CSS}</style>
      <footer className="lfoot-bar" style={{ background: '#0A0A0A', borderTop: '0.5px solid rgba(255,255,255,0.08)', padding: '56px 48px 32px' }}>
        <div className="lfoot-grid" style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1fr 1fr', gap: 40, marginBottom: 40, maxWidth: 1320, margin: '0 auto 40px' }}>
          <div>
            <Link to="/" style={{ display: 'inline-block', textDecoration: 'none', marginBottom: 16 }}>
              <Logo variant="full" theme="dark" size={44} />
            </Link>
            <p style={{ fontFamily: G.mono, fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.5)', marginBottom: 18 }}>
              {t.tagline}
            </p>
            <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                  style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                  onMouseEnter={e => e.currentTarget.querySelector('svg').setAttribute('fill', G.blue)}
                  onMouseLeave={e => e.currentTarget.querySelector('svg').setAttribute('fill', 'rgba(255,255,255,0.7)')}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="rgba(255,255,255,0.7)" style={{ transition: 'fill .15s' }}>
                    <path d={s.d} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {cols.map((col, idx) => (
            <div key={idx}>
              <div style={{ fontFamily: G.mono, fontSize: 9, fontWeight: 600, letterSpacing: '.12em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: 14 }}>{col.title}</div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 9 }}>
                {col.links.map(([h, l], i) => colLink(h, l, `${idx}-${i}`))}
              </ul>
            </div>
          ))}
        </div>
        <div style={{ borderTop: '0.5px solid rgba(255,255,255,0.10)', paddingTop: 20, textAlign: 'center', maxWidth: 1320, margin: '0 auto' }}>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, fontFamily: G.mono }}>{t.copy}</span>
        </div>
      </footer>
    </>
  )
}
